import { render, staticRenderFns } from "./MailBoxPopup.vue?vue&type=template&id=3a9ab8f0&scoped=true"
import script from "./MailBoxPopup.vue?vue&type=script&lang=js"
export * from "./MailBoxPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9ab8f0",
  null
  
)

export default component.exports